import "./App.css";
import "./styles/likemymind.css";
import "./styles/whoweare.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LikemymindLanding from "./components/LikemymindLanding";
import WhoWeAre from "./components/WhoWeAre";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LikemymindLanding />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;